<header class="border-bottom shadow-sm">
  <div class="container">
    <div class="row align-items-center py-1 mt-4 mt-lg-0">
      <div
        class="col-xxl-3 col-xl-3 col-lg-3 col-md-3 mb-4 mb-md-0 col-12 text-center text-md-start"
      >
        <div class="">
          <div class="d-flex align-items-center gap-2">
            <!-- <div class="logo-card">
              <img [src]="authService.subscriptionImage()" />
            </div> -->
            <div class="logo-card">
              <img src="../../../../assets/images/ec528474-e444-11e8-88c5-b39ca7534a35.png" />
            </div>
            <div class="border-start mx-1" style="height: 50px"></div>
            <div style="line-height: 1.2">
              <span class="fw-bold d-block">{{
                authService.appSubscription().name
              }}</span>
              <span class="text-muted d-block" style="font-size: 10px">{{
                authService.appSubscription().code
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
        <div class="d-flex justify-content-center">
          <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    role="button"
                    routerLink="home"
                    routerLinkActive="show"
                  >
                    <i class="fa-solid fa-home me-1"></i>
                    Home
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    role="button"
                    routerLink="shop"
                    routerLinkActive="show"
                  >
                    <i class="fa-solid fa-cart-shopping me-1"></i>
                    Shop
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    role="button"
                    routerLink="orders"
                    routerLinkActive="show"
                  >
                    <i class="fa-regular fa-rectangle-list me-1"></i>
                    My Orders
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>

      <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-3 d-none d-lg-block">
        <div class="d-flex align-items-center justify-content-end">
          <div class="dropdown">
            <a
              class="dropdown-toggle text-reset"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="badge badge bg-light text-dark fs-6">
                <i class="fa-solid fa-circle-user me-1"></i>
                {{ authService.user()?.fullName }}
                <i class="fa-solid fa-chevron-down" style="font-size: 10px"></i>
              </span>
            </a>

            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" (click)="openSubscriptionsModal()">
                  <i class="fa-regular fa-building me-2"></i>
                  Change Subscription
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="authService.logout()">
                  <i class="fa-solid fa-right-from-bracket me-2"></i>
                  Logout
                </a>
              </li>
            </ul>
          </div>

          <div class="text-center ms-6">
            <a
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasCarts"
              role="button"
              aria-controls="offcanvasCarts"
              class="text-reset"
            >
              <div class="text-center">
                <div role="button">
                  <i class="bi bi-cart2 fs-3"></i>
                  <span
                    class="position-relative badge bg-danger"
                    style="top: -15px; right: 5px; width: 25px"
                  >
                    {{ shopService.carts().length }}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Shop Cart -->

<div
  class="offcanvas offcanvas-end overflow-auto"
  tabindex="-1"
  id="offcanvasCarts"
  aria-labelledby="offcanvasCartsLabel"
>
  <div class="offcanvas-header border-bottom">
    <div class="text-start">
      <h5 id="offcanvasCartsLabel" class="mb-0 fs-4">Shopping Carts</h5>
    </div>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <shop-carts></shop-carts>
  </div>
</div>

<!-- Modals -->

<app-modal id="subscriptionsModal">
  <div class="modal-header">
    <h5 class="modal-title">Change Subscription</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    
    <div class="input-group">
      <select class="form-select"
              [(ngModel)]="curAppSubscriptionId"
      >
        @for (appSubscription of authService.appSubscriptions(); track appSubscription.appSubscriptionId) {
          <option [ngValue]="appSubscription.appSubscriptionId">
            {{appSubscription.name}}
          </option>
        }
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="closeModal()">Close</button>
    <button class="btn btn-primary" (click)="changeSubscription()">Confirm</button>
  </div>
</app-modal>

